'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');
const _ = {
    find:     	require('lodash/find'),
    filter:     require('lodash/filter'),
    forEach:    require('lodash/forEach'),
};
const semver = require('semver');
// import { update } from 'lodash';

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
const ShortCourseUtil = require('../../../../app/shared/ShortCourseUtil');

import ErrorBox from '../common/ErrorBox';
import WarningBox from '../common/WarningBox';
import WarningIcon from '../common/WarningIcon';
import ValidationReport from '../validation/ValidationReport';
import ConfirmModal from './ConfirmModal';
import LoadingSpinner from '../loading/LoadingSpinner';
import Tooltip from '../common/Tooltip';

const propTypes = {
    onClose: PropTypes.func.isRequired,
    shortCourseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    show: PropTypes.bool,
    shortCourseLocked: PropTypes.bool,
    publishCallback: PropTypes.func,
};

const defaultProps = {
    show: true,
    shortCourseLocked: false,
    publishCallback: () => {},
};

const emptyValidationObject = {
	implemented: true,
	canPublish: false,
	messages: [],
	warnings: [],
	errors: []
};

class PublishShortCourseModal extends React.Component {
    constructor(props) {
        super(props);
		const shortCourseStoreState = ShortCourseStore.getStateShortCourse(props.shortCourseId, props.projectId, props.channelId);
		const publishValidation = (shortCourseStoreState.shortCourse && shortCourseStoreState.shortCourse.doc) ?  ShortCourseUtil.validateShortCourse(shortCourseStoreState) : emptyValidationObject;
		// validateProhibitsPublish was previously set to always be false. not sure if this was intentional but reverting expected functionality based on actual usage in onShortCourseStoreChange
        const validateProhibitsPublish = publishValidation ? !publishValidation.canPublish : true;

        this.state = {
            publishError: null,
            isBreakingError: null,
            publishActionId: null,
            isBreakingActionId: null,
            shortCourseStoreState,
            publishMessage: '',
			publishValidation, 
			validateProhibitsPublish,
            mandatedBumpMajorVersion: false,
            latestMatchingMajorVersion: null,
            updateInactiveInstances: true,
            updateActiveInstances: true,
            updateInstanceUpdate: false,
            showConfirmModal: false,
        };

        this.forceRecheckCompatibility = this.forceRecheckCompatibility.bind(this);
        this.onChangePublishMessage = this.onChangePublishMessage.bind(this);
        this.onUpdateInactiveChange = this.onUpdateInactiveChange.bind(this);
        this.onUpdateActiveChange = this.onUpdateActiveChange.bind(this);
        this.isUpdateInactiveAllowed = this.isUpdateInactiveAllowed.bind(this);
        this.isUpdateActiveAllowed = this.isUpdateActiveAllowed.bind(this);
        this.setConfirmModalState = this.setConfirmModalState.bind(this);
        this.onPublish = this.onPublish.bind(this);
        this.unsubscribes = [ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))];
    }

    componentDidMount() {
        let initialized = (this.state.shortCourseStoreState.shortCourse && this.state.shortCourseStoreState.shortCourse.doc);
        if (!initialized) {
            ShortCourseActions.getShortCourse(uuid.v4(), { channelId: this.props.channelId, shortCourseId: this.props.shortCourseId });
        }

        const isBreakingActionId = uuid.v4();
        this.setState({ isBreakingActionId: isBreakingActionId }, () => {
            ShortCourseActions.publishIsBreaking(isBreakingActionId, { shortCourseId: this.props.shortCourseId });
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.shortCourseLocked && !this.props.shortCourseLocked) {
            this.forceRecheckCompatibility();
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onShortCourseStoreChange(newState) {
        let additionalState = {};
        let recheckCompatibility = false;
        const shortCourseStoreState = ShortCourseStore.getStateShortCourse(this.props.shortCourseId, this.props.projectId, this.props.channelId);
        const initialized = (shortCourseStoreState.shortCourse && shortCourseStoreState.shortCourse.doc);
		const publishValidation = initialized ?  ShortCourseUtil.validateShortCourse(shortCourseStoreState) : null;
		const validateProhibitsPublish = publishValidation ? !publishValidation.canPublish : emptyValidationObject;

        if (newState.action.id === this.state.publishActionId) {
            if (!newState.action.error) {
                if (this.props.publishCallback) {
                    this.props.publishCallback();
                }

                this.props.onClose();
                return;
            }
            else {
                additionalState = { ...additionalState, publishActionId: null, publishError: newState.action.error, showConfirmModal: false };
            }
        }
        else if (newState.action.id === this.state.isBreakingActionId) {
            if (!newState.action.error) {
                additionalState = {
                    ...additionalState,
                    isBreakingActionId: null,
                    mandatedBumpMajorVersion: shortCourseStoreState.publishCompatibility.isBreaking,
                    latestMatchingMajorVersion: shortCourseStoreState.publishCompatibility.latestMatchingMajorVersion,
                    updateInactiveInstances: !!shortCourseStoreState.publishCompatibility.latestMatchingMajorVersion,
                    updateActiveInstances: !!shortCourseStoreState.publishCompatibility.latestMatchingMajorVersion && !shortCourseStoreState.publishCompatibility.isBreaking,
                };

                if (shortCourseStoreState.publishCompatibility.blockCourseInstanceUpdate) {
                    additionalState = {
                        ...additionalState,
                        updateInstanceUpdate: true,
                        updateInactiveInstances: false,
                        updateActiveInstances: false,
                    };
                }
            }
            else {
                additionalState = { ...additionalState, isBreakingActionId: null, isBreakingError: newState.action.error };
            }
        }

        if (this.state.shortCourseStoreState.shortCourse && this.state.shortCourseStoreState.latest_version !== shortCourseStoreState.latest_version) {
            recheckCompatibility = true;
        }

        this.setState({ shortCourseStoreState: shortCourseStoreState, publishValidation, validateProhibitsPublish, ...additionalState }, () => {
            if (recheckCompatibility) this.forceRecheckCompatibility();
        });
    }

    forceRecheckCompatibility() {
        const props = this.props;
        const isBreakingActionId = uuid.v4();
		const shortCourseStoreState = ShortCourseStore.getStateShortCourse(props.shortCourseId, props.projectId, props.channelId);
		const publishValidation = shortCourseStoreState.initialized ?  ShortCourseUtil.validateShortCourse(shortCourseStoreState) : emptyValidationObject;
		const validateProhibitsPublish = publishValidation ? !publishValidation.canPublish : true;
        this.setState({
            publishValidation,
            validateProhibitsPublish,
            mandatedBumpMajorVersion: false,
            latestMatchingMajorVersion: null,
            updateActiveInstances: true,
            updateInactiveInstances: true,
            isBreakingActionId: isBreakingActionId,
            isBreakingError: null,
            showConfirmModal: false,

        }, () => {
            ShortCourseActions.publishIsBreaking(isBreakingActionId, { shortCourseId: this.props.shortCourseId });
        });
    }

    onChangePublishMessage(e) {
        this.setState({ publishMessage: e.target.value });
    }

    onUpdateInactiveChange(e) {
        this.setState({ updateInactiveInstances: e.target.checked });
    }

    onUpdateActiveChange(e) {
        this.setState({ updateActiveInstances: e.target.checked });
    }

    onPublish() {
        const actionId = uuid.v4();
        this.setState({ publishActionId: actionId, publishError: null },
            ShortCourseActions.publishShortCourse(actionId, {
                shortCourseId: this.props.shortCourseId,
                publish_message: this.state.publishMessage,
                force_bump_major: !!this.state.latestMatchingMajorVersion ? this.state.mandatedBumpMajorVersion || false : false,
                update_inactive: !!this.state.latestMatchingMajorVersion && !this.state.blockCourseInstanceUpdate ? this.state.updateInactiveInstances : false,
                update_active: !this.state.mandatedBumpMajorVersion && !!this.state.latestMatchingMajorVersion && !this.state.blockCourseInstanceUpdate ? this.state.updateActiveInstances : false,
            })
        );
    }

    setConfirmModalState(showBool = true) {
        this.setState({ showConfirmModal: showBool });
    }

    isUpdateInactiveAllowed() {
        return !!this.state.latestMatchingMajorVersion && !this.state.blockCourseInstanceUpdate;
    }

    isUpdateActiveAllowed() {
        return !!this.state.latestMatchingMajorVersion && !this.state.blockCourseInstanceUpdate && !this.state.mandatedBumpMajorVersion;
    }

    render() {
        const pendingPublishCompatibility = !this.state.shortCourseStoreState.initialized || !this.state.shortCourseStoreState.publishCompatibility || !!this.state.isBreakingActionId;

        let nextVersion;
        let coercedSemverNext;
        let compatibleVersionRange;
        if (!pendingPublishCompatibility) {
            nextVersion = this.state.mandatedBumpMajorVersion ? this.state.shortCourseStoreState.publishCompatibility.bumpedVersion : this.state.shortCourseStoreState.publishCompatibility.version;
            coercedSemverNext = semver.coerce(nextVersion);
            if (coercedSemverNext) {
                compatibleVersionRange = `${coercedSemverNext.major}.x.x`;
            }
            else {
                console.warn(`semver unable to coerce nextVersion: "${nextVersion}"`);
            }
        }

        const updateInactiveSelected = this.isUpdateInactiveAllowed() ? this.state.updateInactiveInstances : false;
        const updateActiveSelected = this.isUpdateActiveAllowed() ? this.state.updateActiveInstances : false;
        const updateInactiveTooltip = <span>{Strings['en'].short_course.modals.TT_UPDATE_INACTIVE}</span>; // TODO
        const updateActiveTooltip = <span>{Strings['en'].short_course.modals.TT_UPDATE_ACTIVE} {compatibleVersionRange && `(${compatibleVersionRange})`}</span>; //TODO
        // confirm modal will NOT be displayed if this is the initial publish
        const publishBtnFxn = (!this.state.mandatedBumpMajorVersion && !this.state.latestMatchingMajorVersion) ? this.onPublish : this.setConfirmModalState;

        if (this.state.showConfirmModal) {
            return (
                <ConfirmModal
                    backdrop="static"
                    enforceFocus
                    restoreFocus
                    modalTitle={Strings['en'].short_course.modals.publish.CONFIRM_HEADING}
                    closeHandler={this.setConfirmModalState.bind(this, false)}
                    cancelButtonText={Strings['en'].common.CANCEL_LC}
                    cancelHandler={this.setConfirmModalState.bind(this, false)}
                    buttonText={Strings['en'].short_course.modals.publish.CONFIRM_BUTTON}
                    confirmHandler={this.onPublish}
                    confirmButtonBsStyle="danger"
                    text={(
                        <div>{Strings['en'].short_course.modals.publish.CONFIRM_PROMPT}
                            <ul className="listBulletIndent__spacedMd margin-top-xl margin-bottom-lg">
                                {(this.state.mandatedBumpMajorVersion) &&
                                    <li>{Strings['en'].short_course.modals.publish.VERSION_UPDATED_TO} {this.state.shortCourseStoreState.publishCompatibility.bumpedVersion}.</li>
                                }
                                <li>
                                    {(updateInactiveSelected) ?
                                        Strings['en'].short_course.modals.publish.CONFIRM_INACTIVE_UPDATE_TRUE
                                        :
                                        Strings['en'].short_course.modals.publish.CONFIRM_INACTIVE_UPDATE_FALSE
                                    }  <Tooltip id="confirm-inactive-tt" placement="right">{updateInactiveTooltip}</Tooltip>
                                </li>
                                <li>
                                    {(updateActiveSelected) ?
                                        Strings['en'].short_course.modals.publish.CONFIRM_ACTIVE_UPDATE_TRUE
                                        :
                                        Strings['en'].short_course.modals.publish.CONFIRM_ACTIVE_UPDATE_FALSE
                                    } <Tooltip id="confirm-active-tt" placement="right">{updateActiveTooltip}</Tooltip>
                                </li>
                            </ul>
                        </div>
                    )}
                />
            );
        }
        else {
            return (
                <Modal
                    show={this.props.show}
                    enforceFocus={false}
                    backdrop={false}
                    animation={false}
                    keyboard
                    onHide={this.props.onClose}
                >
                    <Modal.Header closeButton onHide={this.props.onClose}>
                        <Modal.Title>{Strings['en'].short_course.modals.publish.MODAL_HEADER}</Modal.Title>
                    </Modal.Header>
    
                    <Modal.Body>
                        <ErrorBox error={this.state.publishError} />
                        <ErrorBox error={this.state.isBreakingError} />
                        {(this.props.shortCourseLocked) &&
                            <WarningBox>{Strings['en'].short_course.modals.publish.BLOCKED_BY_LOCK}</WarningBox>
                        }
                        {(this.state.shortCourseStoreState.initialized && !this.props.shortCourseLocked) &&
                            <Form>
                                <h2>Compatibility</h2>
                                <hr className="thick hr-color-fg"/>
                                <div className="margin-bottom-xl">
                                    {(pendingPublishCompatibility || !this.state.publishValidation) ?
                                        <div>
                                            <LoadingSpinner /> {Strings['en'].short_course.modals.publish.CHECKING_MSG}
                                        </div>
                                        :
                                        <div className="font-size-md">
                                            {(!this.state.mandatedBumpMajorVersion) ?
                                                (!!this.state.latestMatchingMajorVersion) ?
                                                    <div>
                                                        <div className="margin-bottom-md">
                                                            Current working version {this.state.shortCourseStoreState.publishCompatibility.version} is compatible with previously published version {this.state.shortCourseStoreState.publishCompatibility.latestMatchingMajorVersion}.
                                                        </div>
                                                    </div>
                                                    :
                                                    <div>
                                                        Version {this.state.shortCourseStoreState.publishCompatibility.version} will be published as the initial version.
                                                    </div>
                                                :
                                                <div>
                                                    <div className="margin-bottom-md">
                                                        <WarningIcon /> Current working version {this.state.shortCourseStoreState.publishCompatibility.version} is NOT compatible with previously published version {this.state.shortCourseStoreState.publishCompatibility.latestMatchingMajorVersion}.
                                                    </div>
                                                </div>
                                            }
                                            {(this.state.mandatedBumpMajorVersion) &&
                                                <ul className="listBulletIndent">
                                                    <li>{Strings['en'].short_course.modals.publish.VERSION_UPDATED_TO} {this.state.shortCourseStoreState.publishCompatibility.bumpedVersion}.</li>
                                                    <li>Any active course instances using this course will not be updated.</li>
                                                    {(this.state.blockCourseInstanceUpdate) &&
                                                        <li>Any inactive course instances using this course will not be updated.</li>
                                                    }
                                                </ul>
                                            }
                                        </div>
                                    }
                                </div>
                                <div>
                                    <h2>Publish Message</h2>
                                    <hr className="thick hr-color-fg" />
                                    <div className="margin-bottom-xl">
                                        <Form.Group controlId="modal-input">
                                            <Form.Label>{Strings['en'].short_course.modals.publish.MSG_INPUT_LABEL}</Form.Label>
                                            <Form.Control
                                                value={this.state.publishMessage}
                                                placeholder={Strings['en'].short_course.modals.publish.MSG_INPUT_PHLD}
                                                onChange={this.onChangePublishMessage}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            {(this.state.publishValidation && this.state.publishValidation.implemented) &&
                                <div>
                                    <h2>Validation Information</h2>
                                    <hr className="thick hr-color-fg" />
                                    <div className="margin-bottom-xl">
                                        <ValidationReport
                                            className="mzl-cs-workarea"
                                            validationObj={this.state.publishValidation}
                                        />
                                    </div>
                                </div>
                            }
                            {(!pendingPublishCompatibility && !!this.state.latestMatchingMajorVersion) &&
                                <div>
                                    <h2>Course Instance Options</h2>
                                    <hr className="thick hr-color-fg" />
                                    <div className="margin-bottom-xl">
                                        <Form.Group>
                                            <Form.Check>
                                                <Form.Check.Input
                                                    id="pub-update-inactive"
                                                    checked={updateInactiveSelected}
                                                    onChange={this.onUpdateInactiveChange}
                                                    disabled={!this.isUpdateInactiveAllowed()}
                                                />
                                                <Form.Check.Label htmlFor="pub-update-inactive" bsPrefix="form-check-label margin-left-sm">
                                                    Update inactive course instances <Tooltip id="inactive-tt" placement="right">{updateInactiveTooltip}</Tooltip>
                                                </Form.Check.Label>
                                            </Form.Check>
                                            <Form.Check>
                                                <Form.Check.Input
                                                    id="pub-update-active"
                                                    checked={updateActiveSelected}
                                                    onChange={this.onUpdateActiveChange}
                                                    disabled={!this.isUpdateActiveAllowed()}
                                                />
                                                <Form.Check.Label htmlFor="pub-update-active" bsPrefix="form-check-label margin-left-sm">
                                                    Update compatible active course instances <Tooltip id="active-tt" placement="right">{updateActiveTooltip}</Tooltip>
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </Form.Group>
                                    </div>
                                </div>
                            }
                            </Form>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            disabled={!!this.state.publishActionId
                                || pendingPublishCompatibility
                                || this.props.shortCourseLocked
                                || this.state.validateProhibitsPublish
                                || !!this.state.isBreakingError
                            }
                            onClick={publishBtnFxn}
                        >
                            {Strings['en'].short_course.modals.publish.PUB_BTN_LABEL}
                        </Button>
                    </Modal.Footer>
    
                </Modal>
            );
        }

    }
}

PublishShortCourseModal.propTypes = propTypes;
PublishShortCourseModal.defaultProps = defaultProps;

export default PublishShortCourseModal;